import type { ApplicationVerifier } from 'firebase/auth';
import { firebaseAuthService } from '@/core/services';
import type { ConfirmationResult } from '@/core/services';

export class LoginPorSmsUseCase {
  async execute(phoneNumber: string, appVerifier: ApplicationVerifier): Promise<ConfirmationResult> {
    return firebaseAuthService.sendVerificationCodeToPhone(phoneNumber, appVerifier);
  }
}
